/**
 * ProposalListContainer
 * --
 */
import React from 'react';
import ProposalListPresenter from './ProposalListPresenter';
import { useNavigate } from 'react-router-dom';

/**----------------------------------------
 * [Component] 총관리자: 프로모션 제안 > 컨테이너
 * ----------------------------------------
 */
const ProposalListContainer = (props) => {
  /* ===== ROUTE ===== */
  const navigate = useNavigate();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <ProposalListPresenter navigate={navigate} />
    </>
  );
};

export default ProposalListContainer;
